module.exports = __webpack_public_path__ + "img/strix.cf5eac5a.jpg";